<div class="row mt-3">
  <form [formGroup]="_mFormGroup">
    <div class="row">
      <div class="col-sm-2">
        <label>Location<sup class="mandatory">*</sup></label>
        <select class="form-select" placeholder="Location" formControlName="city" (change)="getSitesByCityId($event)"
          required>
          <option disabled value="">Choose City</option>
          <option *ngFor="let city of cities" [value]="city.locationId">
            {{ city.locationName }}
          </option>
        </select>
      </div>
      <div class="col-sm-2">
        <label>Site<sup class="mandatory">*</sup></label>
        <select class="form-select" formControlName="site" (change)="onsitechange($event)" required>
          <option value="" disabled selected>Choose Site</option>
          <option *ngFor=" let site of sites" [value]="site.siteId">
            {{ site.siteName }}
          </option>
        </select>
      </div>
      <div class="col-sm-2">
        <label>Shift Time<sup class="mandatory">*</sup></label>
        <mat-form-field appearance="outline" class="zoneShiftMapping">
          <mat-select multiple placeholder="Choose Shift Time" formControlName="filterTypeValue">
            <mat-option class="zoneshiftMatSelectCheckbox" *ngFor="let type of shifts" [value]="type.id">
              {{type.value}}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>
      <div class="col-sm-2">
        <label>Route type<sup class="mandatory">*</sup></label>
        <select class="form-select" placeholder="Route type" formControlName="routeType">
          <option disabled value="">Choose Route Type</option>
          <option *ngFor="let type of routetype" [value]="type.type">
            {{type.name }}
          </option>
        </select>
      </div>

      <div class="col-sm-4" style="display: flex; justify-content: flex-end; align-items: center; padding-top: 8px;">
        <button class="btn zoneshift-btn-solid"
          [disabled]="!(mCity.value && mSite.value && mFilterTypeValue.value && mRouteType.value)"
          (click)="showMapping()">Show Mapping</button>
      </div>
    </div>
  </form>
</div>

<div *ngIf="unPushedValues.length > 0 || selrows.length > 0" class="row mt-2">
  <div class="row">
    <div class="col-sm-12 col-md-12">
      <button class="btn zoneshift-btn-solid2" (click)="saveMapping()">Save
        Mapping</button>
    </div>
  </div>
  <div class="container mt-3">
    <div class="container-top" *ngIf="selrows.length > 0">
      <span style="font-size: 14px; font-weight: 500; font-family: 'poppins' !important;">Master Zones</span>
    </div>
    <span class="items mat-color--white tdw-card-thin tdw-border-2
                            tdw-font-14" *ngFor="let row of selrows">
      <mat-checkbox class="zoneCheckBox" [(ngModel)]="row.state" (change)="onValueChecked($event,row)"></mat-checkbox>
      <span style="font-size: 13px; font-weight: 400; font-family: 'poppins' !important;">{{row.value}}</span>
    </span>
  </div>
  <div class="container mt-3">
    <div class="container-top" *ngIf="unPushedValues.length > 0">
      <span style="font-size: 14px; font-weight: 500; font-family: 'poppins' !important;">Selected Master zone</span>
    </div>
    <span class="items mat-color--white tdw-card-thin tdw-border-2
                            tdw-font-14" *ngFor="let row of unPushedValues">
      <mat-checkbox class="zoneCheckBox" [(ngModel)]="row.state"
        (change)="onSelValueChecked($event,row)"></mat-checkbox>
      <span style="font-size: 13px; font-weight: 400; font-family: 'poppins' !important;">{{row.value}}</span>
    </span>
  </div>
</div>

<div class="row mt-2">
  <div class="col-sm-12" style="text-align: end;">
    <img src="./assets/images/excel.svg" style="cursor: pointer;" *ngIf="shiftmapping.length>0" (click)="exportAsXLSX()"
      matTooltip="Export To Excel">
  </div>
</div>

<div class="row mt-3" *ngIf="shiftmapping.length > 0">
  <div class="col-sm-12 col-md-12">
    <div class="table-zone-shift">
      <table class=" table customers-zone-shift">
        <tr style="border-bottom: 1px solid #EFF2F7 !important; background: #ffffff !important;">
          <th>Zone Name</th>
          <th>Shift Time</th>
          <th>Shift Log</th>
          <th>Route Type</th>
          <th>Remove Mapping</th>
        </tr>
        <tr *ngFor="let data of shiftmapping">
          <td>{{data.zoneName}}</td>
          <td>{{data.shiftTime}}</td>
          <td>{{data.shiftLog}}</td>
          <td>{{data.type}}</td>
          <td> <img src="./assets/images/remove.svg" style="cursor: pointer;" (click)="removeMapping(data, 'Removed')"
              matTooltip="Remove Mapping"></td>
        </tr>
      </table>
    </div>
  </div>
</div>